import { render } from "./BlockCounterEdit.vue?vue&type=template&id=1d386930"
import script from "./BlockCounterEdit.vue?vue&type=script&lang=js"
export * from "./BlockCounterEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__